export const PREFERENCES_DEFAULTS = {
	editorMode: 'visual',
	panels: {
		'post-status': {
			opened: true,
		},
	},
	features: {
		fixedToolbar: false,
		welcomeGuide: true,
		fullscreenMode: true,
		showIconLabels: false,
		themeStyles: true,
		showBlockBreadcrumbs: true,
	},
	hiddenBlockTypes: [],
	preferredStyleVariations: {},
	localAutosaveInterval: 15,
};
